"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RequestMethod_1 = require("../../Components/Http/RequestMethod");
const ResponseHandler_1 = require("../../Components/Http/ResponseHandler");
const Druid_1 = require("../../Druid");
const Http_1 = require("../../Utility/Http");
class HttpService {
    constructor(options) {
        this.aborted = [];
        this.inProgress = null;
        this.queue = [];
        this.options = options !== null && options !== void 0 ? options : { link: 'none' };
    }
    /**
     * Send a request
     */
    send(request) {
        let abort;
        let url = request.url;
        if (request.query && Object.keys(request.query).length > 0) {
            url += '?' + Http_1.default.toQueryString(request.query);
        }
        // set headers and credentials
        const init = {
            headers: { ...Druid_1.default.getDefaultRequestHeaders(), ...request.headers },
            credentials: 'include'
        };
        // AbortController only available from Chrome 66+
        // istanbul ignore next
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (window.AbortController) {
            abort = new AbortController();
            init.signal = abort.signal;
        }
        // set method and body
        HttpService.prepareRequest(request, init);
        // send
        return this.execute({
            input: url,
            init: init,
            abort: abort
        });
    }
    /**
     * If there's a currently running request, abort it
     */
    abort() {
        // istanbul ignore next
        if (this.inProgress === null) {
            return;
        }
        // istanbul ignore if
        if (this.inProgress.abort) {
            this.inProgress.abort.abort();
        }
        else {
            this.aborted.push(this.inProgress);
        }
        this.inProgress = null;
    }
    /**
     * Send the request and handle the response
     */
    execute(requestData) {
        if (this.inProgress) {
            // default is 'none'
            switch (this.options.link) {
                case 'ignore':
                    return new Promise(() => {
                    });
                case 'chain':
                    return new Promise((resolve) => {
                        this.queue.push({ request: requestData, resolve: resolve });
                    });
                case 'cancel':
                    this.abort();
                    break;
                default:
                    break;
            }
        }
        this.inProgress = requestData;
        return this.handleResponse(requestData, window.fetch(requestData.input, requestData.init));
    }
    static prepareRequest(request, init) {
        // set method
        init.method = Http_1.default.methodToString(request.method);
        // set body
        if (request.body) {
            if (request.method === RequestMethod_1.default.GET) {
                throw new Error('Received request with `body` but method is `GET`');
            }
            if (request.body instanceof FormData) {
                init.body = request.body;
            }
            else {
                init.body = new FormData();
                Http_1.default.toFormData(request.body, init.body);
            }
        }
    }
    /**
     * Handle response, and start any waiting requests in the queue.
     */
    handleResponse(requestData, responsePromise) {
        const responseHandler = new ResponseHandler_1.default(this.aborted);
        const promise = responseHandler.handleResponse(requestData, responsePromise);
        responsePromise
            .finally(() => {
            // remove requestData from aborted list
            const abortIndex = this.aborted.indexOf(requestData);
            if (abortIndex >= 0) {
                this.aborted.splice(abortIndex, 1);
            }
            // request finished, start next request in queue (if any)
            if (this.inProgress === requestData) {
                this.inProgress = null;
                this.nextInQueue();
            }
        })
            .catch((err) => {
            // After 3 hours of headache, apparently we _need_ to have an additional catch for aborted requests
            // istanbul ignore next
            if (err === undefined || (err instanceof DOMException && err.code === DOMException.ABORT_ERR)) {
                return;
            }
            // no abort, show error details
            console.error('HttpService - error: ', err);
        });
        return promise;
    }
    /**
     * Execute the next request in queue
     */
    nextInQueue() {
        const entry = this.queue.shift();
        if (entry !== undefined) {
            void this.execute(entry.request).then(response => entry.resolve(response));
        }
    }
}
exports.default = HttpService;
//# sourceMappingURL=HttpService.js.map